import { BookingFetchResponseType } from "@models/services/booking";

export const DRAWER_DIRECTION = {
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP: "top",
};

export const KEYBOARD_KEY = {
  ENTER: "Enter",
  ESC: "Escape",
  SPACE: "Space",
};

export const DRAWER_HEIGHT = {
  DEFAULT_OPEN_PERCENT: 95,
  FULL: 100,
  HALF: 50,
  MAX_OPEN_PERCENT: 100,
  MIN_OPEN_PERCENT: 0,
  SECONDARY_POSITION: 18,
  TWENTY_FIVE_PERCENT: 25,
  ZERO: 0,
};

export const SNAP_POINTS = [
  DRAWER_HEIGHT.ZERO,
  DRAWER_HEIGHT.SECONDARY_POSITION,
  DRAWER_HEIGHT.DEFAULT_OPEN_PERCENT,
] as const;

export type SnapPoint = (typeof SNAP_POINTS)[number];

export const DRAWER_UNITS = {
  UNIT_DVH: "dvh",
  UNIT_VH: "vh",
};

export interface DrawerSnapProps {
  children: React.ReactNode;
  direction?: "bottom";
  isOpen: boolean;
  onClose: () => void;
  useSnapPoints?: boolean;
}

export interface DrawerTimeSlotProps {
  bookingSlots: BookingFetchResponseType;
  isBookingDisable: boolean;
  priceLoader: boolean;
}

export const DRAWER_OVERFLOW = {
  EMPTY: "",
  HIDDEN: "hidden",
  SCROLL: "scroll",
};
